import getLang from 'I18n/utils/getLang';
import { useCallback } from 'react';
import { useTrackMarketplaceEvent } from '../../hooks/useTrackMarketplaceEvent';
import { getAppRecommendationTypes } from '../../utils/getAppRecommendationTypes';
import { createMarketplaceEventFactory } from '../index';
export const getMarketplaceInteractionEvent = createMarketplaceEventFactory('Marketplace', 'Marketplace Interaction');

/**
 * Marketplace click result item events
 */

export const getMarketplaceClickResultItemEvent = createMarketplaceEventFactory('Marketplace', 'Marketplace Interaction');
export function useTrackMarketplaceClickResultItem() {
  const trackMarketplaceEvent = useTrackMarketplaceEvent();
  const trackClickResultItem = useCallback(eventProps => {
    trackMarketplaceEvent(getMarketplaceClickResultItemEvent(Object.assign({}, eventProps, {
      action: 'click result item'
    })));
  }, [trackMarketplaceEvent]);
  return {
    trackClickResultItem
  };
}
export const getAppMarketplaceClickResultItemEvent = createMarketplaceEventFactory('Marketplace', 'Marketplace Interaction');
export function useTrackAppMarketplaceClickResultItem() {
  const trackMarketplaceEvent = useTrackMarketplaceEvent();
  const trackClickResultItem = useCallback((result, eventProps) => {
    var _getAppRecommendation;
    trackMarketplaceEvent(getAppMarketplaceClickResultItemEvent(Object.assign({}, eventProps, {
      type: 'integration',
      action: 'click result item',
      value: result.slug,
      applicationId: parseInt(result.sourceId, 10),
      isRecommended: !!result.recommendation,
      recommendationType: (_getAppRecommendation = getAppRecommendationTypes(result)) !== null && _getAppRecommendation !== void 0 ? _getAppRecommendation : undefined,
      preferredLanguage: eventProps.preferredLanguage || getLang()
    })));
  }, [trackMarketplaceEvent]);
  return {
    trackClickResultItem
  };
}
export const getSolutionsDirectoryClickResultItemEvent = createMarketplaceEventFactory('Marketplace', 'Marketplace Interaction');
export function useTrackSolutionsDirectoryClickResultItem() {
  const trackMarketplaceEvent = useTrackMarketplaceEvent();
  const trackClickResultItem = useCallback((result, eventProps) => {
    trackMarketplaceEvent(getSolutionsDirectoryClickResultItemEvent(Object.assign({}, eventProps, {
      type: 'solution provider',
      action: 'click result item',
      value: result.slug,
      tier: result.tier
    })));
  }, [trackMarketplaceEvent]);
  return {
    trackClickResultItem
  };
}